import React, { useState, useEffect } from "react";

const StoryForm = ({ onSave, editData, onCancel }) => {
  const [form, setForm] = useState({
    _id: null,
    coupleName: "",
    description: "",
    image: "",
  });
const [toast, setToast] = useState(null);

const showToast = (message, type = "error") => {
  setToast({ message, type });

  setTimeout(() => {
    setToast(null);
  }, 3000);
};

  // const [toast, setToast] = useState(null);
  // // Load edit data
  // useEffect(() => {
    
  //   console.log('editData:', editData);
  //   if (editData) {
  //     setForm(editData);
  //   }
  //   console.log('Edit_form_up:', form);
  // }, [editData]);

  useEffect(() => {
  if (editData) {
    setForm({
      ...editData,
      preview: null, // no new preview yet
    });
  }
}, [editData]);

  // Handle input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Handle image upload
  // const handleImage = (e) => {
  //   const file = e.target.files[0];

  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setForm({ ...form, image: reader.result });
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleImage = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  const allowedTypes = ["image/jpeg", "image/png", "image/gif"];            
  if (!allowedTypes.includes(file.type)) {
    showToast("Invalid file type. Only JPG, PNG, GIF allowed.");
    e.target.value = "";
    return;
  }
      
  if (file.size > 2 * 1024 * 1024) {
    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);

    showToast(
      `Image too large (${fileSizeMB} MB). Maximum allowed size is 2MB`
    );
    
    e.target.value = "";
    return;
  }

  setForm({
    ...form,
    image: file,
    preview: URL.createObjectURL(file),
  });
};

  const handleSubmit = (e) => {
  e.preventDefault();
  // onSave({
  //   ...form,
  //   image:
  //     form.preview ||
  //     (typeof form.image === "string"
  //       ? form.image
  //       : URL.createObjectURL(form.image)),
  // });
  onSave(form);
};

  return (
    <form onSubmit={handleSubmit}>
      <h3>{editData ? "Edit Story" : "Create Story"}</h3>

      <div>
        <input type="hidden" name="_id" value={form._id} />
        <label>Couple Name</label>
        <input
          type="text"
          name="coupleName"
          value={form.coupleName}
          onChange={handleChange}
          placeholder="Tom & Jeni"
          required
        />
      </div>
    {toast && (
      <div className={`toast ${toast.type}`}>
        {toast.message}
      </div>
    )}
      <div>
        <label>Description</label>
        <textarea
          name="description"
          value={form.description}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label>Upload Image</label>
        <input type="file" onChange={handleImage}  />
      </div>

      {/* Preview */}
      {form.preview ? (
        // ✅ New uploaded image
        <img src={form.preview} alt="preview" width="100" />
      ) : form.image && typeof form.image === "string" ? (
        // ✅ Existing image from backend
        <img
          src={`${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${form.image}`}
          alt="preview"
          width="100"
        />
      ) : null}
      <br/>

      <button type="submit">
        {editData ? "Update Story" : "Create Story"}
      </button>
      <button type="button" onClick={onCancel}>
        Cancel
      </button>
    </form>
  );
};

export default StoryForm;